import React from 'react';
import { Pressable, StyleProp, StyleSheet, ViewStyle } from 'react-native';

import { useColor } from '@/hooks/useColor';

import CloseButton from '../buttons/CloseButton';

interface Props {
  closeModal?: () => void;
  children?: React.JSX.Element | React.JSX.Element[];
  modalStyle?: StyleProp<ViewStyle>;
  showCloseButton?: boolean;
  closeOnTapOutside?: boolean;
}

const ModalCard = ({
  closeModal,
  children,
  modalStyle,
  showCloseButton = true,
  closeOnTapOutside = true
}: Props): React.JSX.Element => {
  const colors = useColor();
  return (
    <Pressable style={styles.centeredView} {...(closeOnTapOutside && { onPress: closeModal })}>
      <Pressable style={[styles.modalView, modalStyle, { backgroundColor: colors.background }]}>
        {showCloseButton && <CloseButton style={styles.closeContainer} onCloseTap={closeModal} hitSlop={10} />}
        {children}
      </Pressable>
    </Pressable>
  );
};

export default ModalCard;

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000000b3'
  },

  modalView: {
    borderRadius: 20,
    padding: 18,
    paddingTop: 36,
    maxHeight: '80%',
    maxWidth: '80%',
    alignItems: 'center'
  },

  closeContainer: {
    position: 'absolute',
    top: 10,
    left: 10
  },

  closeImage: {
    height: 26
  }
});
